module.exports = __webpack_public_path__ + "img/3.ad31ff5d.png";